import axios from "axios";

export const getFullnameByCuit = async cuit => {
  try {
    const data = await axios.get(
      `https://cetaweb.afip.gob.ar/api/v1/contribuyente?cuit=${cuit}&otro=%27T%27`
    );

    return data;
  } catch (error) {
    return null;
  }
};

export const getDataByDomain = async domain => {
  try {
    const data = await axios.get(
      `https://cetaweb.afip.gob.ar/api/v1/automotor?dominio=${domain}`
    );
    return data;
  } catch (error) {
    return null;
  }
};
